import type { SysProject } from '@/types/common';
import { inject, provide, type Ref } from 'vue';

export interface SiteProjectContext {
  currentProject: Ref<SysProject>;
}

const ProvideContextKey = Symbol('SiteProjectContext');

/**
 * @description Provider
 */
export function ProvideSiteProjectContext(context: SiteProjectContext) {
  provide(ProvideContextKey, context);
}

/**
 * @description Injector
 */
export function InjectSiteProjectContext() {
  return inject(ProvideContextKey) as SiteProjectContext;
}
